import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

const ReorderQuestionsAction = (props) => {
  const { onClick, userData, ariaLabel, disabled } = props;
  const { isAdmin, isCoordinator } = userData;
  const isAdminOrCoordinator = isAdmin || isCoordinator;

  return (
    <ButtonWithIcon
      isIcon
      isNaked
      icon="reorder_questions"
      aria-label={ariaLabel}
      onClick={isAdminOrCoordinator ? null : onClick}
      disabled={isAdminOrCoordinator || disabled}
      tabIndex={0}
    />
  );
};

ReorderQuestionsAction.propTypes = {
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string.isRequired,
};

ReorderQuestionsAction.defaultProps = {
  onClick: () => {},
  className: '',
};

const mapStateToProps = (state) => {
  const { userData } = state;

  return {
    userData,
  };
};

export default connect(mapStateToProps)(ReorderQuestionsAction);
